import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Names the "/gyms" step of the breadcrumb on a gym's page, not just on the list. */
export const Route = createFileRoute("/(private)/gyms")({
  loader: () => ({ crumb: m.gyms_title() }),
  component: Outlet,
});
